import { a as o } from "../../../chunk-OA3DH5LS-40f95340.js";
const a = o("Toggle").parts(
  "control",
  "label",
  "labelTextContainer",
  "root",
  "thumb",
  "tooltipIcon"
);
export {
  a as ToggleAnatomy
};
//# sourceMappingURL=Toggle.anatomy.es.js.map
